var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "has-friends" },
        [
          _c("c-switcher", {
            attrs: { label: "Есть знакомые, работающие в компании" },
            model: {
              value: _vm.hasFriends,
              callback: function ($$v) {
                _vm.hasFriends = $$v
              },
              expression: "hasFriends",
            },
          }),
        ],
        1
      ),
      _c("transition", { attrs: { name: "slide" } }, [
        _vm.hasFriends
          ? _c(
              "div",
              { staticClass: "who" },
              [
                _c("c-textarea", {
                  attrs: {
                    "floating-label": "Укажите, кто именно",
                    clearable: true,
                  },
                  model: {
                    value: _vm.friends,
                    callback: function ($$v) {
                      _vm.friends = $$v
                    },
                    expression: "friends",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }